const C = {
  name: "Dashboard",
  dimensions: { width: 24, height: 24 },
  content: `
    <svg fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3C6.47715 3 2 7.47715 2 13V16C2 17.6569 3.34315 19 5 19H8.53513C9.22675 20.1956 10.5194 21 12 21C13.4806 21 14.7733 20.1956 15.4649 19H19C20.6569 19 22 17.6569 22 16V13C22 7.47715 17.5228 3 12 3ZM16 17H19C19.5523 17 20 16.5523 20 16V13C20 8.58172 16.4183 5 12 5C7.58172 5 4 8.58172 4 13V16C4 16.5523 4.44772 17 5 17H8C8 14.7909 9.79086 13 12 13C12.4622 13 12.9061 13.0784 13.3191 13.2226L15.1676 10.4458C15.4737 9.9861 16.0944 9.86152 16.5542 10.1676C17.0139 10.4736 17.1385 11.0944 16.8324 11.5541L14.9819 14.3339C15.6151 15.0415 16 15.9758 16 17ZM12 15C10.8954 15 10 15.8954 10 17C10 18.1046 10.8954 19 12 19C13.1046 19 14 18.1046 14 17C14 15.8954 13.1046 15 12 15Z" />
    </svg>

  `
};
export {
  C as Dashboard
};
